import { render, staticRenderFns } from "./ChannelRemoved.vue?vue&type=template&id=761fb3ac&scoped=true"
import script from "./ChannelRemoved.vue?vue&type=script&lang=js"
export * from "./ChannelRemoved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761fb3ac",
  null
  
)

export default component.exports